<template>
  <main-layout>
    <b-loading :is-full-page="true" :active.sync="loading" />
    <div v-if="!loading">
      <h1 class="title">Modifica {{ productType.code }}</h1>
      <product-type-form :item="productType" />
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"
import store from "@/store"

import ProductTypeForm from "@/components/ProductTypeForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    ProductTypeForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    productType: get("productTypes/productType")
  },
  async beforeRouteUpdate(to, from, next) {
    this.loading = true
    await this.fetchProductType(to.params.id)
    this.loading = false
    next()
  },
  beforeDestroy() {
    store.set("productTypes/productType", {})
  },
  async mounted() {
    this.loading = true
    await this.fetchProductType(this.$route.params.id)
    this.loading = false
  },
  methods: {
    fetchProductType: call("productTypes/find")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
